import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useScreen } from '../lib/useScreen';
import { ParticlesCanvas, Faq, Bar } from '../components/landing';

const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const C = { turquesa:'#5dc1b9', mango:'#FDBE02' };

export default function PreguntasFrecuentes() {
  const navigate = useNavigate();
  const { isMobile } = useScreen();

  return (
    <div style={{ fontFamily:font, color:'#fff', background:'#0a0a0a', minHeight:'100vh', position:'relative', overflow:'hidden' }}>
      <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, zIndex:0 }}>
        <ParticlesCanvas />
      </div>

      <div style={{ position:'relative', zIndex:1, maxWidth:680, margin:'0 auto', padding:isMobile?'2rem 1.2rem':'4rem 2rem' }}>
        {/* Back */}
        <button onClick={() => navigate(-1)} style={{ background:'none', border:'none', color:'rgba(255,255,255,0.5)', fontSize:14, cursor:'pointer', fontFamily:font, padding:0, marginBottom:32, display:'flex', alignItems:'center', gap:6 }}>
          ← Volver
        </button>

        {/* Header */}
        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:14 }}>
          <Bar /><p style={{ fontSize:isMobile?11:13, color:C.turquesa, fontWeight:500, letterSpacing:2, margin:0 }}>PREGUNTAS FRECUENTES</p>
        </div>
        <h1 style={{ fontFamily:serif, fontSize:isMobile?24:34, fontWeight:400, margin:'0 0 8px', color:'#fff' }}>
          Resolvemos tus dudas
        </h1>
        <p style={{ fontSize:isMobile?14:16, color:'rgba(255,255,255,0.5)', margin:'0 0 32px' }}>
          Todo lo que necesitas saber antes de entrar a T&D
        </p>

        {/* FAQ items */}
        <div style={{ display:'flex', flexDirection:'column', gap:10, marginBottom:40 }}>
          <Faq q="¿Que es la red neuronal de proyectos?" a="Es una visualizacion viva de todos los proyectos de la comunidad T&D, conectados entre si por afinidad. Cada burbuja es un emprendedor real con su proyecto. Las lineas muestran a quienes estan en etapas o industrias similares — son tus posibles matches."/>
          <Faq q="¿Que es la Gestion de Conocimiento Personal?" a="Es una forma de organizar tus ideas, aprendizajes y reflexiones en un sistema interconectado, como un segundo cerebro. T&D toma esa idea — popularizada por apps como Obsidian — y la adapta especificamente al camino emprendedor: para que pienses tu proyecto, conectes ideas y encuentres gente afin."/>
          <Faq q="¿En que se diferencia T&D de Notion u Obsidian?" a="Notion es genial para organizar informacion de equipos. Obsidian es genial para tu cerebro personal con notas locales. T&D es lo unico que combina ambos: tienes tu cerebro privado de proyecto (Mis Ideas) + lo que decides compartir te conecta con otros emprendedores en una red viva (Pensamientos + Red Neuronal). Notion no es intimo, Obsidian no es social. T&D es ambos."/>
          <Faq q="¿Como entro a la red? ¿Que cuesta?" a="Te registras gratis como Free Observer, completas tu proyecto en el onboarding, y tu burbuja aparece automaticamente en la red. Puedes escribir Pensamientos publicos sin pagar. Para contactar a tus matches directamente necesitas Doer ($139 MXN/mes)."/>
          <Faq q="¿Mis ideas privadas son realmente privadas?" a="Si, totalmente. Tus Ideas viven en un espacio separado, encriptado y solo accesible para ti. Nunca aparecen en la red, ni en matches, ni nadie de T&D las ve. Es tu cerebro digital privado."/>
          <Faq q="¿Como funciona el match con otros emprendedores?" a="El sistema analiza tu proyecto (etapa, industria, modelo, habilidades, necesidades, ubicacion) y lo que escribes en tus Pensamientos publicos. Detecta automaticamente personas afines y te las muestra. Tu decides si quieres conectar con ellas."/>
          <Faq q="¿Necesito tener un negocio para entrar?" a="No. Puedes entrar con solo una idea o incluso sin una. El programa se adapta a tu etapa."/>
          <Faq q="¿Quienes son Genio y Luca?" a="Son tus dos companeros de viaje con inteligencia artificial. Genio te inspira y motiva, Luca te aterriza y te pone a trabajar."/>
          <Faq q="¿Puedo cancelar en cualquier momento?" a="Si, sin penalizacion. Puedes subir, bajar o cancelar tu membresia cuando quieras."/>
          <Faq q="¿Que es Human Stories & Ideas?" a="Un espacio intimo donde los miembros comparten historias reales — miedos, satisfacciones, aprendizajes. Para lo que sientes de verdad."/>
          <Faq q="¿Como se ve mi proyecto en la red?" a="Tu proyecto aparece como una neurona con su nombre real. Los demas emprendedores pueden ver tus pensamientos publicos y conectar contigo. La transparencia es parte del valor de la comunidad."/>
        </div>

        {/* CTA */}
        <div style={{ textAlign:'center' }}>
          <button onClick={() => navigate('/')} style={{
            background:'linear-gradient(135deg, #534AB7, #1D9E75)',
            color:'#fff',
            border:'none',
            borderRadius:50,
            padding:isMobile?'14px 32px':'16px 40px',
            fontSize:isMobile?14:16,
            fontWeight:500,
            cursor:'pointer',
            fontFamily:font,
            boxShadow:'0 0 40px rgba(93,193,185,0.3)',
          }}>
            Volver al inicio
          </button>
        </div>
      </div>
    </div>
  );
}
